import React from 'react';
import { isAnyArray } from 'core/utils';

function TableColumnEllipsis(props) {
	const {
		item,
		column: { key, maxChars },
	} = props;
	let textToShow = item[key];
	if (!textToShow) return null;
	if (isAnyArray(textToShow)) {
		textToShow = textToShow.map(data => data.label).join(', ');
	}
	if (textToShow.length < (maxChars ? maxChars : 30)) {
		return textToShow;
	}
	return <div title={textToShow}>{textToShow.substr(0, maxChars ? maxChars : 30)}&hellip;</div>;
}

export default TableColumnEllipsis;
